import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/axios"; // Global axios config - withCredentials for all API calls
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
